import { useState } from "react";

const useMaxLengthValidation = (maxLength: number) => {
  const [isMaxLengthReached, setIsMaxLengthReached] = useState(false);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    const currentValue = e.currentTarget.value;
    const hasTextSelected =
      e.currentTarget.selectionStart !== e.currentTarget.selectionEnd;
    const isPrintableCharacter = e.key.length === 1;

    if (
      isPrintableCharacter &&
      currentValue.length >= maxLength &&
      !hasTextSelected
    ) {
      setIsMaxLengthReached(true);
      setTimeout(() => {
        setIsMaxLengthReached(false);
      }, 1000);
    } else {
      setIsMaxLengthReached(false);
    }
  };

  return { isMaxLengthReached, handleKeyDown };
};

export default useMaxLengthValidation;
